import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";

import * as highFrequencyWordActions from "../../redux/actions/highFrequencyWord";
import { useQuery } from "../../hooks/QueryHooks";
import { State } from "../../redux/store";
import Placeholder from "../../components/Placeholder";
import {
  INTRO_STAGE,
  FINISH_STAGE,
} from "../../redux/reducers/stateIdentifiers";
import IntroductionPage from "./IntroductionPage";
import GamePage from "./GamePage";
import FinishBoard from "./FinishBoard";
import Logo from "../../components/Logo";
import { pageTitle } from "../../util/Util";

interface Props {
  itemLeft: number;
  scale: number;
}

const HighFrequencyWordGame = (props: Props) => {
  const { itemLeft, scale } = props;
  const dispatch = useDispatch();
  useQuery();

  const { queryLoaded, grade, unit, gameConfigLoaded } = useSelector(
    (state: State) => state.shared
  );
  const { stage, words } = useSelector(
    (state: State) => state.highFrequencyWord
  );

  useEffect(() => {
    const init = async () => {
      await dispatch(highFrequencyWordActions.importSpec(grade, unit));
      dispatch(highFrequencyWordActions.initSpec());
    };
    if (queryLoaded && grade && unit) init();
  }, [queryLoaded]);

  if (!queryLoaded) return <Placeholder type="loading" />;
  if (!grade || !unit) return <Placeholder type="invalid" />;
  if (!gameConfigLoaded) return <Placeholder type="loading" />;
  if (!words.length) return <Placeholder type="invalid" />;

  return (
    <div>
      <Helmet>
        <title>
          {pageTitle("High Frequency Game", `Small Books Unit ${unit}`, grade)}
        </title>
      </Helmet>
      <Logo grade={grade} unit={unit} left={itemLeft} />
      {stage === INTRO_STAGE && <IntroductionPage />}
      {stage !== INTRO_STAGE && <GamePage itemLeft={itemLeft} />}
      {stage === FINISH_STAGE && <FinishBoard scale={scale} left={itemLeft} />}
    </div>
  );
};

export default HighFrequencyWordGame;
